import { CommissionEndpoints } from '@/modules/accounting/commission/api/commissionEndpoints'

/**
 * Commission endpoint instance
 * instantiate Commission api class with a different api path
 */
export const commissionEndpoints = new CommissionEndpoints()
